<template>
  <header class="ishorizontal-topbar">
    <div class="navbar-header">
      <div class="d-flex">
        <!-- LOGO -->
        <div class="navbar-brand-box">
          <router-link to="/dashboard" class="logo logo-dark">
            <span class="logo-sm">
              <img :src="logo" alt="" height="22" />
            </span>
            <span class="logo-lg">
              <img :src="logo" alt="" height="22" />
            </span>
          </router-link>

          <router-link to="/dashboard" class="logo logo-light">
            <span class="logo-sm">
              <img :src="logo" alt="" height="22" />
            </span>
            <span class="logo-lg">
              <img :src="logo" alt="" height="22" />
            </span>
          </router-link>
        </div>

        <button
          type="button"
          class="btn btn-sm px-3 font-size-16 d-lg-none header-item"
          data-bs-toggle="collapse"
          data-bs-target="#topnav-menu-content"
        >
          <i class="fa fa-fw fa-bars"></i>
        </button>

        <div class="d-none d-sm-block ms-2 align-self-center">
          <h4 class="page-title">{{ pagetitle }}</h4>
        </div>
      </div>

      <div class="d-flex">
        <div class="dropdown d-inline-block">
          <button type="button" class="btn header-item">
            <b>{{ user.name }} | {{ user.company.name }}</b>
          </button>
        </div>
        <div class="dropdown d-inline-block language-switch">
          <button
            type="button"
            class="btn header-item"
            data-bs-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <b>{{ currentLocale }}</b>
          </button>
          <div class="dropdown-menu dropdown-menu-end">
            <a
              href="javascript:void(0);"
              @click="$i18n.locale = 'en'"
              class="dropdown-item side-nav-link-ref notify-item language"
              data-lang="eng"
            >
              <span class="align-middle">English</span>
            </a>

            <a
              href="javascript:void(0);"
              @click="$i18n.locale = 'es'"
              class="dropdown-item side-nav-link-ref notify-item language"
              data-lang="sp"
            >
              <span class="align-middle">Español</span>
            </a>

            <a
              href="javascript:void(0);"
              @click="$i18n.locale = 'pt'"
              class="dropdown-item side-nav-link-ref notify-item language"
              data-lang="pt-br"
            >
              <span class="align-middle">Português</span>
            </a>
          </div>
        </div>

        <div class="dropdown d-inline-block">
          <button
            @click="onLogout()"
            type="button"
            class="btn header-item noti-icon"
            id="page-header-notifications-dropdown-v"
            data-bs-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            Logout
          </button>
        </div>
      </div>
    </div>
    <div class="topnav">
      <div class="container-fluid">
        <nav class="navbar navbar-light navbar-expand-lg topnav-menu">
          <div class="collapse navbar-collapse" id="topnav-menu-content">
            <ul class="navbar-nav" v-if="$store.state.isAuthenticated">
              <li class="nav-item dropdown" v-for="(item, i) in menuItems" :key="i">
                <a
                  class="nav-link dropdown-toggle arrow-none"
                  href="#"
                  id="topnav-dashboard"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <span class="m-1">
                    <i :class="`text-secondary h4 mdi ${item.icon}`"></i>
                  </span>
                  <span data-key="t-dashboards">{{ $t(item.title) }}</span>
                  <div class="arrow-down"></div>
                </a>
                <a
                  class="nav-link dropdown-toggle arrow-none show-only-mobile"
                  href="#"
                  id="topnav-dashboard"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  v-for="(child, j) in item.children"
                  :key="j"
                >
                  <span data-key="t-dashboards">
                    <router-link :to="child.path" class="dropdown-item side-nav-link-ref" data-key="t-report">
                      {{ $t(child.title) }}
                    </router-link>
                  </span>
                </a>
                <div class="dropdown-menu hide-mobile" aria-labelledby="topnav-dashboard">
                  <router-link
                    v-for="(child, j) in item.children"
                    :key="j"
                    :to="child.path"
                    class="dropdown-item side-nav-link-ref"
                    data-key="t-report"
                  >
                    {{ $t(child.title) }}
                  </router-link>
                </div>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </div>
  </header>
</template>
<script>
import { layoutMethods, layoutComputed } from '@/state/helpers';
import { defineComponent } from 'vue';
import { mapActions } from 'vuex';
import { useToast } from 'vue-toastification';
import auth from '@/services/auth.services.js';
import themes from '@/themes.config';
/**
 * Horizontal-navbar component
 */
export default defineComponent({
  props: {
    width: {
      type: String,
      required: true
    },
    pagetitle: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    layoutscroll: {
      type: Boolean,
      required: true
    }
  },
  setup() {
    const toast = useToast();
    return { toast };
  },
  computed: {
    logo() {
      return themes[window.location.origin]?.logo || require('@/themes/default-logo.png');
    },
    user() {
      const user = auth.getLoggedUser();

      if (user?.name) {
        return user;
      }

      return { company: {} };
    },
    menuItems() {
      return this.$store.state.menuItems;
    },
    currentLocale() {
      return (this.$i18n?.locale || '').toUpperCase();
    },
    ...layoutComputed,
    currentLanguage() {
      return require(`@/assets/images/flags/${this.$i18n.locale}.jpg`);
    }
  },
  mounted() {
    this.initNav();
  },
  watch: {
    type: {
      //   immediate: true,
      deep: true,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          switch (newVal) {
            case 'dark':
              document.body.setAttribute('data-topbar', 'dark');
              break;
            case 'light':
              document.body.setAttribute('data-topbar', 'light');
              document.body.removeAttribute('data-layout-size', 'boxed');
              break;
            default:
              document.body.setAttribute('data-topbar', 'dark');
              break;
          }
        }
      }
    },
    layoutscroll: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          switch (newVal) {
            case false:
              document.body.setAttribute('data-layout-scrollable', 'false');
              break;
            case true:
              document.body.setAttribute('data-layout-scrollable', 'true');
              break;
            default:
              document.body.setAttribute('data-layout-scrollable', 'false');
              break;
          }
        }
      }
    },
    width: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          switch (newVal) {
            case 'boxed':
              document.body.setAttribute('data-layout-size', 'boxed');
              break;
            case 'fluid':
              document.body.setAttribute('data-layout-size', 'fluid');
              document.body.removeAttribute('data-layout-size');
              break;
            default:
              document.body.setAttribute('data-layout-size', 'fluid');
              break;
          }
        }
      }
    }
  },
  methods: {
    initNav() {
      var links = document.getElementsByClassName('side-nav-link-ref');
      var matchingMenuItem = null;
      for (var i = 0; i < links.length; i++) {
        if (window.location.pathname === links[i].pathname) {
          matchingMenuItem = links[i];
          break;
        }
      }

      if (matchingMenuItem) {
        matchingMenuItem.classList.add('active');
        var parent = matchingMenuItem.parentElement;

        /**
         * TODO: This is hard coded way of expading/activating parent menu dropdown and working till level 3.
         * We should come up with non hard coded approach
         */
        if (parent) {
          parent.classList.add('active');
          const parent2 = parent.parentElement;
          if (parent2) {
            parent2.classList.add('active');
            const parent3 = parent2.parentElement;
            if (parent3) {
              parent3.classList.add('active');
              const parent4 = parent3.parentElement;
              if (parent4) {
                parent4.classList.add('active');
                const parent5 = parent4.parentElement;
                if (parent5) {
                  parent5.classList.add('active');
                  const parent6 = parent5.parentElement;
                  if (parent6) {
                    parent6.classList.add('active');
                  }
                }
              }
            }
          }
        }
      }
    },
    ...layoutMethods,
    ...mapActions(['setReportMovimento']),
    /**
     * Menu clicked show the submenu
     */
    onMenuClick(event) {
      event.preventDefault();
      const nextEl = event.target.nextSibling;
      if (nextEl && !nextEl.classList.contains('show')) {
        const parentEl = event.target.parentNode;
        if (parentEl) {
          parentEl.classList.remove('show');
        }
        nextEl.classList.add('show');
      } else if (nextEl) {
        nextEl.classList.remove('show');
      }
      return false;
    },
    /**
     * Returns true or false if given menu item has child or not
     * @param item menuItem
     */
    hasItems(item) {
      return item.subItems !== undefined ? item.subItems.length > 0 : false;
    },
    hasManyItems(item) {
      return item.subItems !== undefined ? item.subItems.length > 8 : false;
    },
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar();
    },
    onLogout() {
      this.$auth.logout();
    }
  }
});
</script>
